#import "~/graphql/fragments/fields/accordion.graphql"
#import "~/graphql/fragments/fields/links.graphql"
#import "~/graphql/fragments/assets/image.graphql"
#import "~/graphql/fragments/contentBuilder/contentBlocks.graphql"
#import "~/graphql/fragments/seo/index.graphql"

fragment infoSection on info_Entry {
    __typename
    id
    slug
    title
    sfTitle
    contentBlocks {
        ... contentBlocks
    }
    image {
        ... image
    }
    links {
        ... links
    }
    accordion {
        ... accordionFields
    }
    contactTitle
    contactInformation
    seo {
        ... socialFragment
    }
}
